module.exports = __webpack_public_path__ + "img/logo3.a5f981a1.svg";